import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

// Why tracking couldn't produce a fix: the permission was refused, or the
// device has no geolocation support / the position lookup failed.
type GeolocationError = 'denied' | 'unavailable';

interface GeolocationState {
  tracking: boolean;
  position: [number, number] | null; // [lng, lat] — deck.gl coordinate order
  accuracy: number | null; // meters (coords.accuracy)
  error: GeolocationError | null;
  toggleTracking: () => void;
  setError: (error: GeolocationError) => void;
  setFix: ({ position, accuracy }: { position: [number, number]; accuracy: number }) => void;
}

export const INITIAL_GEOLOCATION_STORE_STATE: Pick<
  GeolocationState,
  'tracking' | 'position' | 'accuracy' | 'error'
> = {
  tracking: false,
  position: null,
  accuracy: null,
  error: null,
};

export const useGeolocationStore = create<GeolocationState>()(
  immer((set) => ({
    ...INITIAL_GEOLOCATION_STORE_STATE,
    toggleTracking: () =>
      set((draft) => {
        const next = !draft.tracking;
        draft.tracking = next;
        draft.error = null;
        if (!next) {
          draft.position = null;
          draft.accuracy = null;
        }
      }),
    setError: (error) =>
      set((draft) => {
        draft.error = error;
      }),
    setFix: ({ position, accuracy }) =>
      set((draft) => {
        draft.position = position;
        draft.accuracy = accuracy;
        draft.error = null;
      }),
  })),
);
